


import Vue from 'vue';
import HeaderComponent from '@/components/header/header.vue';
import FooterComponent from '@/components/footer/footer.vue';
import StickyOfferLinkComponent from '@/components/sticky-offer-link/sticky-offer-link.vue';
import {pageTitle} from "@/components/common/pageTitle";

export default Vue.extend({
    created(): void {
        pageTitle.setBaseTitle();
    },
    computed: {
        isNotFoundPage(): boolean {
            return this.$route.meta.notFound;
        }
    },
    components: {
        'app-header': HeaderComponent,
        'app-footer': FooterComponent,
        'app-sticky-offer-link': StickyOfferLinkComponent
    }
});
